module.exports = __webpack_public_path__ + "static/media/change_circle.7867ffe0.svg";